module.exports = __webpack_public_path__ + "img/1538302777.4efd6596.jpg";